import React from 'lib/react';
import {
  EVGrid, EVPaper, makeStyles, EVTypography,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import {
  IMAGE_FILES_PATH, SUPPORT_UK_USERS, SUPPORT_UK_CALL,
  SUPPORT_US_USERS,
  SUPPORT_CANADA_USERS,
} from 'constants/AppConstants';
import { SERVICE_REQUEST_ROUTE } from 'constants/RouteConstants';
import { Link } from 'lib/router';

const useStyles = makeStyles((theme) => ({
  gridbox: {
    margin: '0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  image: {
    width: '100%',
  },
  head: {
    fontStyle: 'normal',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '36px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: theme.evPalette.charcoal[800],
  },
  body: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0em',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    color: theme.evPalette.charcoal[800],
    wordWrap: 'break-word',
  },
  paper: {
    display: 'flex',
    flex: 1,
    margin: '0px',
    padding: '24px',
    gap: '45px',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      margin: '20px',
    },
  },
  linkText: {
    color: theme.evPalette.ocean[500],
    textDecoration: 'none',
    cursor: 'pointer',
  },
  serviceRequestFormContainer: {
    margin: '0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    height: '100%',
    '&>button#backToSupportBtn': {
      width: 'fit-content',
      textTransform: 'capitalize',
    },
    '& iframe': {
      width: '100%',
      height: '100%',
    },
  },
  serviceRequestFormFrame: {
    border: '0px',
  },
}));

function SupportPage() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <EVPaper className={classes.paper}>
      <EVGrid className={classes.gridbox}>
        <img className={classes.image} src={`${IMAGE_FILES_PATH}/US&Cad_Map.svg`} alt="US-MAP" />
        <EVTypography className={classes.head}>{t('support_US&CAD')}</EVTypography>
        <EVTypography className={classes.body}>
          <div>
            <Link
              id="serviceRequestBtn"
              className={classes.linkText}
              to={SERVICE_REQUEST_ROUTE}
            >
              {t('support_submit_email_request')}
            </Link>
          </div>
          <div>
            <a
              id="supportUSBtn"
              target="_blank"
              className={classes.linkText}
              href={SUPPORT_US_USERS}
              rel="noreferrer"
            >
              {t('support_clickHere')}
            </a>
            {' '}
            {t('support_forUS')}
          </div>
          <div>
            <a
              id="supportCADBtn"
              target="_blank"
              className={classes.linkText}
              href={SUPPORT_CANADA_USERS}
              rel="noreferrer"
            >
              {t('support_clickHere')}
            </a>
            {' '}
            {t('support_forCAD')}
          </div>
        </EVTypography>
      </EVGrid>
      <EVGrid className={classes.gridbox} style={{ '@media (min-width: 640px)': { marginLeft: 40 } }}>
        <img className={classes.image} src={`${IMAGE_FILES_PATH}/UK_Map.svg`} alt="US-MAP" />
        <EVTypography className={classes.head}>{t('support_UK')}</EVTypography>
        <EVTypography className={classes.body}>
          {' '}
          <div>
            {t('support_Call')}
            {SUPPORT_UK_CALL}
          </div>
          <div>
            {t('support_Email')}
            {' '}
            <a id="supportUKBtn" className={classes.linkText} href={`mailto:${SUPPORT_UK_USERS}`}>{SUPPORT_UK_USERS}</a>
          </div>
          (
          {t('support_NotLive_UK')}
          )
        </EVTypography>
      </EVGrid>
    </EVPaper>
  );
}

export default SupportPage;
